import { fitCheck } from '../content/fitCheck';
import { FitCheck } from '../islands/FitCheck';
import { LeadText } from '../lib/marks';
import s from '../site.module.css';
import { Section, SiteLayout } from './layout';

/** The fit check at /fit-check: the existing open check in the public pages' design. */
export function FitCheckPage() {
  const f = fitCheck;
  const steps = f.nextSteps.items;
  return (
    <SiteLayout>
      <section className={s.hero} aria-labelledby="hero-title">
        <div className={`${s.container} ${s.fitHero}`}>
          <div className={s.heroCopy}>
            <h1 id="hero-title">{f.hero.headline}</h1>
            <p className={s.lede}>{f.hero.subhead}</p>
          </div>
          <FitCheck />
        </div>
      </section>

      <Section tone="white" labelledBy="back-title">
        <div className={s.split}>
          <h2 id="back-title">{f.whatComesBack.headline}</h2>
          <ul className={s.checkList}>
            {f.whatComesBack.list.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </Section>

      <Section tone="sky" labelledBy="verdicts-title">
        <div className={s.sectionHead}>
          <h2 id="verdicts-title">{f.verdicts.headline}</h2>
        </div>
        <table className={s.verdictTable}>
          <caption className="visually-hidden">{f.verdicts.caption}</caption>
          <thead>
            <tr>
              {f.verdicts.columns.map((c) => (
                <th key={c} scope="col">
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {f.verdicts.rows.map((row) => (
              <tr key={row.key}>
                <th scope="row">{row.label}</th>
                <td>{row.meaning}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>

      <Section tone="white" labelledBy="ways-title">
        <div className={s.sectionHead}>
          <h2 id="ways-title">{f.ways.headline}</h2>
        </div>
        <ul className={s.plainList}>
          <li>
            <LeadText item={f.ways.here} />
          </li>
          <li>
            <LeadText item={f.ways.web} />
          </li>
        </ul>
      </Section>

      <Section tone="navy" labelledBy="stops-title">
        <div className={s.sectionHead}>
          <h2 id="stops-title">{f.stops.headline}</h2>
        </div>
        <ul className={s.plainList}>
          {f.stops.list.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Section>

      <Section labelledBy="next-title">
        <div className={s.sectionHead}>
          <h2 id="next-title">{f.nextSteps.headline}</h2>
        </div>
        <ul className={s.plainList}>
          {[steps.reps, steps.teams, steps.review, steps.notFit].map((item) => (
            <li key={item.lead}>
              <LeadText item={item} />
            </li>
          ))}
        </ul>
      </Section>
    </SiteLayout>
  );
}
